// Module
var code = "<span [ngClass]=\"{'flex-column-all-center': type !== 'action'}\" *ngIf=\"show\"> <div class=\"circle-loader\" [ngClass]=\"type !== '' && 'circle-loader--' + type \"></div> <h5 *ngIf=\"type === ''\" class=\"loader-text\">{{'Παρακαλώ περιμένετε' | translate}}</h5> </span> <ng-content *ngIf=\"!show\"></ng-content> ";
// Exports
module.exports = code;